import { Navigate, Route, Routes } from "react-router-dom";
import HomePage from "./page";
import ChartPopupPage from "./chart-popup/page";
import ExamplesPage from "./examples/page";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/chart-popup" element={<ChartPopupPage />} />
      <Route path="/examples" element={<ExamplesPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
